<template>
  <div class="col-12 px-0 mt-3">
    <div class="form-group">
      <form-control
        v-model="draft.subject"
        title="Subject"
      />
    </div>
    <div class="form-group">
      <label>Alert Lists</label>
      <multiselect
        v-model="myAlertLists"
        :options="alertLists"
        :allow-empty="true"
        :searchable="true"
        :multiple="true"
        :show-labels="false"
        :class="{
          'is-invalid': ((error && error.errors.alertLists) ? error.errors.alertLists : []).length > 0
        }"
        placeholder="Select Alert Lists"
        class="multiselect"
        style="cursor:pointer"
        select-label="Select"
        track-by="id"
        label="name"
      />
      <form-control-error
        :errors="(error && error.errors.alertLists) ? error.errors.alertLists : []"
      />
    </div>

    <form-control
      v-model="draft.preheaderText"
      title="Preview Text"
    />

    <div class="form-group">
      <label>Send at (London Time)</label>
      <flat-pickr
        :class="{
          'is-invalid': ((error && error.errors.sendAt) ? error.errors.sendAt : []).length > 0
        }"
        :config="{enableTime: true}"
        v-model="sendAt"
        placeholder="Select date and time"
        required
        @input="updateSendAt"
      />
      <form-control-error
        :errors="(error && error.errors.sendAt) ? error.errors.sendAt : []"
      />

      <div class="mt-3">
        <table class="table table-sm" style="font-size: 12px">
          <thead>
            <tr>
              <th>New York</th>
              <th>London</th>
              <th>Dubai</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ newYork }}</td>
              <td>{{ london }}</td>
              <td>{{ dubai }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="form-group">
      <form-control
        v-model="draft.fromName"
        :errors="error ? error.errors.fromName : []"
        title="From Name"
      />
    </div>

    <div class="form-group">
      <form-control
        v-model="draft.fromEmail"
        :errors="error ? error.errors.fromEmail : []"
        type="email"
        title="From Email"
      />
    </div>

    <div class="form-group">
      <div class="btn-group">
        <button
          :class="`btn ${draft.sections[1].advertisement === 'indices-banner' ? 'btn-primary' : 'btn-secondary'}`"
          @click="changeAdvertisement('indices-banner')"
        >
          Indices banner
        </button>
        <button
          :class="`btn ${draft.sections[1].advertisement === 'unique-indices-banner' ? 'btn-primary' : 'btn-secondary'}`"
          @click="changeAdvertisement('unique-indices-banner')"
        >
          Indices banner - alternate
        </button>
        <button
          :class="`btn ${draft.sections[1].advertisement === 'pro-trial' ? 'btn-primary' : 'btn-secondary'}`"
          @click="changeAdvertisement('pro-trial')"
        >
          Pro trial
        </button>
        <button
          :class="`btn ${!draft.sections[1].advertisement ? 'btn-primary' : 'btn-secondary'}`"
          @click="changeAdvertisement(null)"
        >
          No advertisement
        </button>
      </div>
    </div>
    <tabs class="button-tabs" align="center">
      <tab name="Email">
        <div class="email-preview-content shadow my-5 mx-auto">
          <div
            v-if="isShadowDOMSupported"
            ref="shadowPreview"
            v-html="emailHtml"
          />
          <div
            v-else
            v-html="emailHtml"
          />
        </div>
      </tab>
      <tab name="Web" v-if="newsletterType.slug === 'friday-five'">
        <iframe border="0" width="100%" height="1500" :src="insightsUrl(`specials/friday-five/draft?draftId=${draft.newsletterDraftId}`)" />
      </tab>
    </tabs>
  </div>
</template>

<script>
import gateway from '@/gateway'
import Tab from '@/components/Tab'
import Tabs from '@/components/Tabs'
import moment from 'moment-timezone'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: 'GenericPreviewStep',

  components: {
    Tab,
    Tabs,
    ToggleButton,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterType: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
      default: null,
    },
    emailHtml: {
      required: false,
      default: '',
      type: String,
    }
  },

  data: () => ({
    isLoading: false,
    alertLists: [],
    publishAlertLists: [],
    myAlertLists: [],
    error: null,
    isShadowDOMSupported: false,
    sendAt: null,
  }),

  async mounted () {
    await this.getAlertLists()
    this.isShadowDOMSupported = !!document.head.attachShadow
    this.draft.alertLists = this.draft.alertLists || []
    if (this.newsletterType.slug === 'tellimer-today') {
      this.draft.sections[1].advertisement = this.draft.sections[1].advertisement || null
    }

    this.draft.preheaderText = this.draft.preheaderText ? this.draft.preheaderText : this.defaultPreheaderText
    this.myAlertLists = this.alertLists.filter((al) => this.draft.alertLists.indexOf(al.id) !== -1)
    if (this.draft.sendAt) {
      this.sendAt = moment.tz(this.draft.sendAt, 'UTC').tz('Europe/London').format('YYYY-MM-DD hh:mm:00.000Z')
    }
    this.onUpdated()
  },

  computed: {
    showIndicesBannerToggle() {
      return this.newsletterType.slug === 'tellimer-today'
    },
    london() {
      return moment.tz(this.sendAt || new Date(), 'Europe/London').tz('Europe/London').format('YYYY-MM-DD hh:mm a z')
    },
    newYork() {
      return moment.tz(this.sendAt || new Date(), 'Europe/London').tz('America/New_York').format('YYYY-MM-DD hh:mm a z')
    },
    dubai() {
      return moment.tz(this.sendAt || new Date(), 'Europe/London').tz('Asia/Dubai').format('YYYY-MM-DD hh:mm a z')
    },
    defaultPreheaderText () {
      if (this.newsletterType.slug.includes('briefing')) {
        if (this.draft.sections[0].body.introduction) {
          var tmp = document.createElement("DIV")
          tmp.innerHTML = this.draft.sections[0].body.introduction.replace(/></g, '> <')
          return (tmp.textContent || tmp.innerText || "").substr(0, this.synopsisMaxLength).replace("\n", ' ')
        }

        return (Object.values(this.draft.sections[1].body).filter((a) => {
          return !!a.article
        }).map(a => a.title).join(', '))
      }
      if (this.newsletterType.slug === 'weekly-round-up') {
        return this.draft.sections[0].body.title
      }

      if (this.newsletterType.slug === 'friday-five') {
        return this.draft.sections[0].body.firstArticle.title
      }

      if (this.newsletterType.slug === 'tellimer-today') {
        return Object.values(this.draft.sections[1].body).map(a => a.title).join('. ')
        // sections[1].body
      }

      return ''
    },
  },

  watch: {
    myAlertLists (alertLists) {
      this.draft.alertLists = alertLists.map((a) => a.id)
    },
    errors (data) {
      this.error = data
    },
  },

  activated () {
    this.$emit('get-preview')
  },

  methods: {
    updateSendAt () {
      this.draft.sendAt = this.sendAt ? moment.tz(this.sendAt, 'Europe/London').toISOString() : null
    },

    updateDraft () {
      this.$emit('update')
    },

    changeAdvertisement (ad) {
      this.draft.sections[1].advertisement = ad
      this.updateDraft()
    },

    async getAlertLists () {
      const {data} = await this.$http.get('/alert-lists')
      this.alertLists = data.data
    },

    insightsUrl (url) {
      return `${process.env.VUE_APP_INSIGHTS_URL}${url}`
    },

    onUpdated() {
      this.$emit('getPreview')
    }
  },
}
</script>


<style lang="scss">
.email-preview-content {
  overflow-y: auto;
  // fixes a bug in IE
  flex-basis: 60vh;
  flex-grow: 1;
  height: 600px;
  max-width: 800px;
}

.el-date-editor {
  &.is-invalid {
    input {
      border-color: $danger;
    }
  }
}
</style>

